import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getInstructorData,
  getInstructorwithStudentData,
  getInstructorDataWithClass,
} from "../../../lib/taskmanageview";
import { getDataforInstructorActiveStudent } from "../../../lib/classdetailview";
import { getInstructorIdData } from "../../../lib/classview";
import { updateData, deleteIdData } from "../../../lib/taskm";
//import { TicketClose, TicketOpen, TicketTotal } from "../../imagepath";
import { useAuth } from "../../../usercontext";
import TaskEdit from "../../ui/taskedit";

export default function TaskManageList() {
  const [tasklist, setTaskList] = useState([]);
  const { profile, setProfile } = useAuth();
  const [category, setCategory] = useState("Student");
  const [newAnswer, setNewAnswer] = useState();
  const { taskStatus, setTaskStatus } = useAuth();
  const [selectedStudent, setSelectedStudent] = useState("All");
  const [selectedClass, setSelectedClass] = useState("");
  const [collapseOpenClose, setCollapseOpenClose] = useState(false);
  const [instructorStudent, setInstructorStudent] = useState([]);
  const [instructorClass, setInstructorClass] = useState([]);
  // 1 : All , 2 : Open ,  4 : Close
  const [tab, setTab] = useState(1);
  const [tabCurrent, setTabCurrent] = useState(0);

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      GetFilterData();
    }
  };

  const collapseAll = () => {
    setCollapseOpenClose(!collapseOpenClose);
  };

  async function GetAllData() {
    let tasks = await getInstructorData(profile.id);
    console.log("tasks", tasks);
    setFilterData(tasks);
  }

  function setFilterData(tasks) {   
    setTaskList([]); 
    if (tab === 1) {
      //All
      setTaskList(tasks);
      setTabCurrent(0);
    }
    //tasks = await getInstructorData(profile.id);

    //Current
    if (tab === 2)
      setTaskList(tasks.filter((opt) => opt.statusway === "Current"));
    //Later
    if (tab === 3)
      setTaskList(tasks.filter((opt) => opt.statusway === "Later"));
    //Closed
    if (tab === 4)
      setTaskList(tasks.filter((opt) => opt.statusway === "Closed"));
    /*
   { 
    if(tabCurrent  === 0) //Current No choise
      setTaskList(tasks.filter((opt) => opt.status === true));

    if(tabCurrent  === 1) //Current
      setTaskList(tasks.filter((opt) => opt.status === true && opt.isCurrent===true));

      if(tabCurrent  === 2) //Later
      setTaskList(tasks.filter((opt) => opt.status === true && opt.isCurrent===false));
  }
  //tasks = await getInstructorDataWithStatus(profile.id,true);

  if (tab === 4)
    //Close
    { 
      if(tabCurrent  === 0) //Current No choise
        setTaskList(tasks.filter((opt) => opt.status === false));

      if(tabCurrent  === 1) //Current
        setTaskList(tasks.filter((opt) => opt.status === false && opt.isCurrent===true));

        if(tabCurrent  === 2) //Later
        setTaskList(tasks.filter((opt) => opt.status === false && opt.isCurrent===false));
    }
        */
  }

  async function GetStudentData(studentId) {
    let tasks = await getInstructorwithStudentData(profile.id, studentId);
    console.log("StudentData",tasks);
    setFilterData(tasks);
  }

  async function GetClassData(clas) {
    console.log("Class Data", clas, tab);
    let tasks = await getInstructorDataWithClass(profile.id, clas);
    //console.log("tasks",tasks);

    setFilterData(tasks);
  }

  async function GetInstructorStudentData() {
    const students = await getDataforInstructorActiveStudent(profile.id);
    setInstructorStudent(students);
    setSelectedStudent(students[0].studentId);

    const clas = await getInstructorIdData(profile.id);
    setInstructorClass(clas);
    setSelectedClass(clas[0].id);
  }

  useEffect(() => {
    setTaskList([]);
    console.log("tasklist",tasklist);
    
    setTab(2);
    GetFilterData();
  }, [selectedClass, selectedStudent, category]);

  function GetFilterData() {
    if (category === "Student") {
      if (selectedStudent !== "All") GetStudentData(selectedStudent);
      else GetAllData();
    } // Category Class
    else {
      if (selectedClass) GetClassData(selectedClass);
    }
  }

  useEffect(() => {
    console.log("Category Changed");
    GetFilterData();
  }, [tab, tabCurrent]);

  useEffect(() => {
    if (selectedStudent !== "All") GetStudentData(selectedStudent);
    else GetAllData();
    GetInstructorStudentData();
    //GetClassData(selectedClass);
  }, []);

  async function ChangeTaskCurrent(Id, isCurrent) {
    await updateData({
      id: Id,
      isCurrent: !isCurrent,
    });
    GetFilterData();
  }

  async function ChangeTaskStatus(Id, statusway) {
    console.log("ChangeTaskStatus", Id, statusway);

    await updateData({
      id: Id,
      statusway: statusway,
    });
    GetFilterData();
  }

  const toggleTab = (id) => {
    setTab(id);
  };

  const essentialheader = (name, buttonname, buttonlink) => {
        return (
          <div className="d-flex pb-1 justify-content-between align-items-center">
            <div>
              <h3>{name}</h3>
              <p></p>
            </div>
            <div className="d-flex">
              <div className="ticket-btn-grp">
                    <Link
                      to={buttonlink}
                    >
                      {buttonname}
                    </Link>
                </div>
              </div>
          </div>
      );
    }
  
  return (
    <>
      {/*}
      <div className="settings-top-widget">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="card stat-info ttl-tickets">
              <div className="card-body">
                <img src={TicketTotal} alt="Total Tickets" />
                <h3>50</h3>
                <p>Total Tickets</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="card stat-info open-tickets">
              <div className="card-body">
                <img src={TicketOpen} alt="Open Tickets" />
                <h3>30</h3>
                <p>Open Tickets</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="card stat-info close-tickets">
              <div className="card-body">
                <img src={TicketClose} alt="Close Tickets" />
                <h3>20</h3>
                <p>Close Tickets</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      */}
      <div className="settings-widget">
        <div className="settings-inner-blk p-0">
          <div className="comman-space pb-0">
          {essentialheader(
          "Agenda",
          "Add New Item",
          "/instructor/instructor-addnewtask"
          )}
            <div className="category-tab tickets-tab-blk">
              <div className="row mb-4 align-items-center h-100">
                <div className="row w-75">
                  <div className="form-group d-flex justify-content-around">
                    <div
                      className="form-check fs-3"
                      style={{ marginRight: "30px" }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="category"
                        id="flexRadioDefault1"
                        value="Student"
                        checked={category === "Student"}
                        onChange={(e) => setCategory("Student")}
                      />
                      <label
                        className="form-check-label fs-4"
                        htmlFor="flexRadioDefault1"
                      >
                        Student
                      </label>
                    </div>
                    <div className="form-check fs-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="category"
                        id="flexRadioDefault2"
                        value="Class"
                        checked={category === "Class"}
                        onChange={(e) => setCategory("Class")}
                      />
                      <label
                        className="form-check-label fs-4"
                        htmlFor="flexRadioDefault2"
                      >
                        Class
                      </label>
                    </div>
                  </div>
                  {category === "Student" ? (
                    <div>
                      <h5>Students</h5>
                      <div className="select-container">
                        <select
                          value={selectedStudent}
                          onChange={(e) => setSelectedStudent(e.target.value)}
                          className="select-box"
                        >
                          {/*}
                          <option key="aa" value="All">
                            All
                          </option>
                          */}
                          {instructorStudent.map(function (data, ix) {
                            return (
                              <option key={ix} value={data.studentId}>
                                {data.studentName + " " + data.studentSurname}
                              </option>
                            );
                          })}
                        </select>
                        <div className="icon-container">
                          <i className="fa-solid fa-chevron-down"></i>
                        </div>
                      </div>
                    </div>
                  ) : (
                    //Class
                    <div>
                      <h5>Class</h5>
                      <div className="select-container">
                        <select
                          value={selectedClass}
                          onChange={(e) => setSelectedClass(e.target.value)}
                          className="select-box"
                        >
                          {instructorClass.map(function (data, ix) {
                            return (
                              <option key={ix} value={data.id}>
                                {data.class_name}
                              </option>
                            );
                          })}
                        </select>
                        <div className="icon-container">
                          <i className="fa-solid fa-chevron-down"></i>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Ticket Tab */}
            <div className="category-tab tickets-tab-blk">
              <div className="mb-2 d-flex  h-100">
                <div className="flex-fill">
                  <ul className="nav nav-justified" >
                    <li className="nav-item" style={{flexBasis: "auto"}}>
                      <Link
                        //to="#all"
                        className={tab === 1 ? "nav-link active" : "nav-link"} 
                        //data-bs-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(1);
                        }}
                      >
                        All
                      </Link>
                    </li>
                    <li className="nav-item" style={{flexBasis: "auto"}}>
                      <Link
                        //to="#open"
                        className={tab === 2 ? "nav-link active" : "nav-link"}
                        //data-bs-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(2);
                        }}
                      >
                        Agenda-1
                      </Link>
                    </li>
                    <li className="nav-item" style={{flexBasis: "auto"}}>
                      <Link
                        //to="#open"
                        className={tab === 3 ? "nav-link active" : "nav-link"}
                        //data-bs-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(3);
                        }}
                      >
                        Agenda-2
                      </Link>
                    </li>
                    <li className="nav-item" style={{flexBasis: "auto"}}>
                      <Link
                        //to="#close"
                        className={tab === 4 ? "nav-link active" : "nav-link"}
                        //data-bs-toggle="tab"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTab(4);
                        }}
                      >
                        Closed
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="text-center">
                  <button
                    className="btn btn-outline-info"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    onClick={() => collapseAll()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-chevron-double-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                      <path
                        fillRule="evenodd"
                        d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                    </svg>{" "}
                    Collapse All
                  </button>
                </div>
              </div>
            </div>
            {/* Ticket Tab */}

            {/* Referred Ticket List */}
            <div className="tab-content">
              <div className="settings-tickets-blk table-responsive">
                {/* Referred Users */}
                <div className="table-responsive">
                  <div className="container-fluid">
                    <div className="row w-95">
                      <div className="col">
                        <div className="row mb-2">
                          <div className="col">
                            <strong>Topic</strong>
                          </div>
                          <div className="col">
                            <strong>Student</strong>
                          </div>
                          <div className="col">
                            <strong>Date</strong>
                          </div>
                          <div className="col">
                            <strong>Status</strong>
                          </div>
                          <div className="col">
                            <strong>Detail</strong>
                          </div>
                          <div className="col">
                            <strong>Process</strong>
                          </div>
                        </div>
                        {tasklist.map(function (data) {
                          return (
                            <div key={data.id} className="row mb-2">
                              <div className="col">{data.subject}</div>
                              <div className="col">{data.studentinfo}</div>
                              <div className="col">{data.setDate}</div>
                              <div className="col">
                                <div className="select-container">
                                  <select
                                    value={data.statusway}
                                    onChange={(e) =>
                                      ChangeTaskStatus(data.id, e.target.value)
                                    }
                                    className="select-box"
                                  >
                                    <option key={1} value="Current">
                                    Agenda-1
                                    </option>
                                    <option key={2} value="Later">
                                    Agenda-2
                                    </option>
                                    <option key={3} value="Closed">
                                      Closed
                                    </option>
                                  </select>
                                  <div className="icon-container">
                                    <i className="fa-solid fa-chevron-down"></i>
                                  </div>
                                </div>
                              </div>
                              <div className="col">
                                <a
                                  className="btn btn-outline-info"
                                  data-bs-toggle="collapse"
                                  href={`#collapseExample${data.id}`}
                                  role="button"
                                  aria-expanded="false"
                                  aria-controls={`collapseExample${data.id}`}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-chevron-double-down"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                    />
                                  </svg>
                                </a>
                              </div>
                              <div className="col">
                                <div className="profile-share">
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleDelete(data.id)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                              <div
                                className={`collapse ${
                                  collapseOpenClose ? "show" : ""
                                }`}
                                id={`collapseExample${data.id}`}
                              >
                                <div className="row">
                                  <div className="col" colSpan={6}>
                                    <TaskEdit
                                      value={data.desc}
                                      setValue={setNewAnswer}
                                      id={data.id}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Referred Users */}
              </div>
            </div>
            {/* Referred Ticket List */}
          </div>
        </div>
      </div>
    </>
  );
}
